import styled from 'styled-components';

import { Button } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';

const borderRadius = '6px';

export const ButtonGroupStyled = styled.div`
  display: flex;
  flex-wrap: nowrap;
  outline: 0 solid ${Colors.AquaMiddle};
  border-radius: ${borderRadius};

  transition: outline-width 0.3s ease-in-out;

  &:focus-visible {
    outline: 2px solid ${Colors.AquaMiddle};
  }

  &[data-size='small'] {
    height: 34px;

    & button {
      height: 34px;
      max-height: 34px;
    }
  }

  &[data-size='large'] {
    height: 38px;

    & button {
      height: 38px;
      max-height: 38px;
    }
  }

  & button {
    border-radius: 0;

    &:focus-visible {
      z-index: 11;
    }

    &:hover {
      border-radius: 0;
    }

    &:first-child {
      border-top-left-radius: ${borderRadius};
      border-bottom-left-radius: ${borderRadius};

      &:hover {
        border-top-left-radius: ${borderRadius};
        border-bottom-left-radius: ${borderRadius};
      }
    }

    &:last-child {
      border-top-right-radius: ${borderRadius};
      border-bottom-right-radius: ${borderRadius};

      &:hover {
        border-top-right-radius: ${borderRadius};
        border-bottom-right-radius: ${borderRadius};
      }
    }
  }
`;

export const ButtonGroupIconButton = styled(Button)`
  padding-right: 11px;
  padding-left: 11px;
  min-width: unset;
`;
